import './App.css';
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Dhenkanal360page from './Dhenkanal360page/Dhenkanal360page';
import Dhenkanal360odiapage from './Dhenkanal360odiapage/Dhenkanal360odiapage';
import DhenkanalNavbarPage from './DhenkanalNavbarPage/DhenkanalNavbarPage';
import AboutPage from './AboutPage/aboutpage';
import Dhenkanal360FirstPage from './Dhenkanal360FirstPage/dhenkanal360firstpage';
import Dhealnavbar from './Navbar/dhealnavbar';
import { useState } from 'react';
import './Dhenkanal360FirstPage/widget';
import OfficeReview from './OfficeReview/OfficeReview';
import PageNotFound from './Dhenkanal360FirstPage/PageNotFound';

function App() {
  const [theme, setTheme] = useState("light");
  const [fontSize, setFontSize] = useState(100);

  const toggleTheme = () =>
    setTheme(theme === "light" ? "dark" : "light");

  const increaseFont = () =>
    setFontSize(prev => Math.min(prev + 10, 150));

  const decreaseFont = () =>
    setFontSize(prev => Math.max(prev - 10, 70));

  const resetFont = () => setFontSize(100);

  useEffect(() => {
    if (window.RAG_WIDGET?.init && !document.getElementById("rag-widget-root")) {
      window.RAG_WIDGET.init();
    }
  }, []);
  return (
    <div className={`theme-${theme}`}
      style={{ fontSize: fontSize + "%" }}
    >
      <Routes>
        <Route path="/" element={<DhenkanalNavbarPage
          toggleTheme={toggleTheme}
          increaseFont={increaseFont}
          decreaseFont={decreaseFont}
          resetFont={resetFont}
        />} />
        <Route path="/dhenkanal360page" element={<Dhenkanal360page />} />
        <Route path="/dhenkanal360odiapage" element={<Dhenkanal360odiapage />} />
        <Route path="/aboutpage" element={<AboutPage
          toggleTheme={toggleTheme}
          increaseFont={increaseFont}
          decreaseFont={decreaseFont}
          resetFont={resetFont}
        //  fontSize={fontSize}
        />} />
        <Route
          path="/dhenkanalfirstpage"
          element={
            <Dhenkanal360FirstPage
              toggleTheme={toggleTheme}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              resetFont={resetFont}
              theme={theme}
            />
          }
        />

        <Route path="/dhealnavbar" element={<Dhealnavbar />} />
        <Route path="/officeReview" element={<OfficeReview />} />
        {/* 404 NOT FOUND PAGE */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
